import React from 'react';
import { Modal } from 'antd';
import { CameraOutlined } from '@ant-design/icons';
import ReusableBarcodeScanner from './ReusableBarcodeScanner';

const BarcodeScannerModalWrapper = ({ 
  visible, 
  onClose, 
  onScan, 
  title = "Scan Barcode",
  allowManualInput = true,
  autoClose = true,
  showResult = true,
  size = 'medium',
  width = '90%',
  maxWidth = '600px'
}) => {
  return (
    <Modal
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <CameraOutlined style={{ color: '#1890ff' }} />
          <span>{title}</span>
        </div>
      }
      open={visible}
      onCancel={onClose}
      width={width}
      style={{ maxWidth: maxWidth }}
      footer={null}
      destroyOnClose
      centered
    >
      <ReusableBarcodeScanner
        visible={true}
        onClose={onClose}
        onScan={onScan}
        title={title}
        allowManualInput={allowManualInput}
        autoClose={autoClose}
        showResult={showResult}
        size={size}
      />
    </Modal>
  );
};

export default BarcodeScannerModalWrapper;

